module.exports = __webpack_public_path__ + "static/media/0102.06a18f3a.mp4";